import { jsx as l, jsxs as _ } from "react/jsx-runtime";
import { memo as b, useCallback as j } from "react";
import { Select as y } from "./index99.mjs";
import { MenuItem as C } from "@mui/material";
const k = b(
  ({
    labelType: n = "inside",
    variant: s = "outlined",
    fullWidth: m = !0,
    size: d = "small",
    onChange: r,
    currencies: a,
    isDisabled: p,
    label: o,
    name: i,
    error: u,
    ...h
  }) => {
    const f = j(
      (e, t) => {
        const { value: c } = e.target;
        r && r(e, c, t);
      },
      [r]
    ), x = `currency_select_${i}_${o}`;
    return /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
      y,
      {
        labelId: x,
        fullWidth: m,
        label: o,
        labelType: n,
        onChange: f,
        disabled: p,
        error: u,
        size: d,
        name: i,
        variant: s,
        ...h,
        children: a.map(({ value: e, title: t, symbol: c }) => /* @__PURE__ */ _(C, { value: e, children: [
          /* @__PURE__ */ l("span", { children: c }),
          t
        ] }, e))
      }
    ) });
  }
);
export {
  k as CurrencySelect
};
//# sourceMappingURL=index100.mjs.map
